module.exports = __webpack_public_path__ + "static/media/TokenDistributionInfographics.56ebc2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/TokenDistributionInfographics.jpg
// module id = 1534
// module chunks = 0